import { createSlice } from '@reduxjs/toolkit'
import { createLiveCall, getLiveCallStatus, makeLiveCall } from 'services/liveCall'
import { LiveCall } from 'services/types/live-call'
import { FETCHING_STATUS } from 'utils/constants'
import { LiveCallState } from './types'

const initialState: LiveCallState = {
  isCalling: false,
  liveCall: undefined,
  leadId: undefined,
}

type SetLiveCallPayload = {
  payload: Partial<LiveCallState>
}

const { reducer, actions } = createSlice({
  name: 'liveCall',
  initialState,
  reducers: {
    setLiveCall: (state, { payload }: SetLiveCallPayload) => ({
      ...state,
      ...payload,
    }),
    clearLiveCall: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createLiveCall.fulfilled, (state, { payload }) => {
      if (payload.status === 'SUCCESS') {
        return {
          ...state,
          liveCall: {
            live_call_id: payload.data.data.live_call_id,
            lead_activity_id: payload.data.data.lead_activity_id,
          } as LiveCall,
        }
      }
      return state
    })

    builder.addCase(makeLiveCall.fulfilled, (state, { payload }) => ({
      ...state,
      isCalling: payload.status === 'SUCCESS',
    }))

    builder.addCase(getLiveCallStatus.fulfilled, (state, { payload }) => ({
      ...state,
      isCalling: payload.status === FETCHING_STATUS.success && Boolean(payload.data.data.lead_id),
      leadId: payload.status === FETCHING_STATUS.success ? payload.data.data.lead_id || undefined : undefined,
    }))
  },
})

export default reducer
export { actions }
